module.exports = __webpack_public_path__ + "media/images/default/shared/down-arrow-2bcde0130aa34d4b770d02cf29103b44.svg";